import { IncentiveOffer } from 'modules/incentivesMarket/types';

export const getPurchaseQuantityBounds = (
  currentOffer: IncentiveOffer | null,
  availableSharesValue: number
): { min: number; max: number } => {
  const max = Math.max(0, availableSharesValue);
  if (!currentOffer) {
    return { min: max > 0 ? 1 : 0, max };
  }
  if (!currentOffer.isPartialAmountEnabled) {
    return { min: max, max };
  }
  const rawMin = currentOffer.minUnitsPerAcceptance ?? 1;
  if (max === 0) {
    return { min: 0, max: 0 };
  }
  const min = Math.max(1, Math.min(rawMin, max));
  return { min, max };
};

export const isPartialMinSharesValid = (
  isPartialAmountEnabled: boolean,
  minUnitsPerAcceptance: number,
  sharesTotal: number
): boolean => {
  if (!isPartialAmountEnabled) {
    return true;
  }
  if (sharesTotal <= 0) {
    return false;
  }
  return minUnitsPerAcceptance >= 1 && minUnitsPerAcceptance <= sharesTotal;
};
